<app-loading [(ativo)]="ativo" text="Estamos carregando suas informações. Vale a pena aguardar!"></app-loading>

<div *ngIf="executar" [hidden]="ativo" id="screenContent" class="background-squircles">

  <div class="container align-content-lg-end">
    <a routerLink="/relatorio-sintetico" routerLinkActive="active" style="text-decoration: none;">
      <div class="report-number row">
        &#x2190; Voltar
      </div>
    </a>

    <p class="hidden-mobile disclaimertop" *ngIf="controlessolicitarRelAnalitico">Os dados constantes neste Relatório
      podem ser utilizados pela Serasa
      Experian, clientes e parceiros em suas soluções de proteção do crédito, prevenção a fraudes, aprimoramento da
      qualidade de dados, segmentações de audiências, análise de potencial de mercado e criação de modelos e perfis
      comportamentais.</p>

    <div *ngIf="controlessolicitarRelAnalitico">

      <div class="fx-flex fx-row reportinfo items-center  ">
        <div class="fx-flex fx-col mx-2">

          <app-alert [titulo]="'Relatório'" [tipo]="'info'">

            <p>Número do relatório - {{this.protocolo}} |
              {{datacriacaoprotocolo | date:"longDate":"IST":"pt"}} |
              {{datacriacaoprotocolo | date:"HH:mm"}}
              &nbsp;contendo informações de {{datainicioinformacao | date:"shortDate":"IST":"pt"}} a
              {{datafiminformacao | date:"shortDate":"IST":"pt"}}
            </p>

          </app-alert>
        </div>

        <div class="fx-flex fx-col mx-2 mb-2">
          <button class="btnGerarPdf" (click)="exportToPdf()">
            <i class="fa fa-file-pdf-o mx-1" aria-hidden="true"></i>
            Gerar PDF
          </button>
        </div>


      </div>

      <m-expansion-panel *ngIf="MostrarDadosCadastrais" [id]="'accDadosCadastrais'" [title]="'Dados de identificação'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosCadastrais && dadosCadastrais.length > 0">
          <table id="id-table-informacaoCadastro" class="table table-striped table-borderless" aria-label="Tabela de informação de cadastro">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%" style="word-wrap: break-word;">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of sortByAtributo(dadosCadastrais, 'atributo'); index as i">
                <td>
                  {{ dados.atributo | naoinformado }}
                </td>
                <td class='clsAtributo'>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="id-div-informacaoCadastro-nao-encontrado" class="info-not-found"
          *ngIf="!dadosCadastrais || dadosCadastrais.length == 0">Nenhuma informação encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarLocalizacao" [id]="'accDadosLocalizacao'" [title]="'Dados de localização'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosLocalizacao && dadosLocalizacao.length > 0">
          <table id="id-table-informacaoLocalizacao" class="table table-striped table-borderless" aria-label="Tabela de informação de Localização">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of sortByAtributo(dadosLocalizacao, 'atributo'); index as i">
                <td>
                  {{ dados.atributo | naoinformado }}
                </td>
                <td class='clsAtributo'>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosLocalizacao-nao-encontrado" class="info-not-found"
          *ngIf="!dadosLocalizacao || dadosLocalizacao.length == 0">Nenhuma informação encontrada
        </div>
      </m-expansion-panel>

      <div class="mensagem-rodape-accordion" id="divAtualizarDados" *ngIf="MostrarLocalizacao">
        <p id="id-p-dadosDeLocalizacao-mensagem-com-link" [innerHTML]>Para atualização dos dados de localização,
          consulte as opções no menu <a href="https://www.serasa.com.br/meus-dados/alterar-dados/"
            target="_blank">Editar dados</a> </p>
      </div>
      <m-expansion-panel *ngIf="MostrarOutrosCadastrais" [id]="'accDadosOutrosCadastrais'"
        [title]="'Outros dados cadastrais'" [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosOutrosCadastrais && dadosOutrosCadastrais.length > 0">
          <table id="id-table-informacaoOutrosCadastrais" class="table table-striped table-borderless" aria-label="Tabela de informações de outros dados cadastrais">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of sortByAtributo(dadosOutrosCadastrais, 'atributo'); index as i">
                <td>
                  {{ dados.atributo | naoinformado }}
                </td>
                <td class='clsAtributo'>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosOutrosCadastrais-nao-encontrado" class="info-not-found"
          *ngIf="!dadosOutrosCadastrais || dadosOutrosCadastrais.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarPartiSocietaria" [id]="'accDadosParticipacaoSocietaria'"
        [title]="'Dados de participação societária'" [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosParticipacaoSoc && dadosParticipacaoSoc.length > 0">
          <table id="id-table-infParticipacaoSoc" class="table table-striped table-borderless" aria-label="Tabala de participação societária">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of dadosParticipacaoSoc; index as i"
                [ngStyle]="dados.atributo === 'Empresa' && {'font-weight':'bold'}">
                <td>
                  {{ dados.atributo | naoinformado }}
                </td>
                <td class='clsAtributo'>
                  {{ dados.informacao | naoinformado }}
                </td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosParticipacaoSoc-nao-encontrado" class="info-not-found"
          *ngIf="!dadosParticipacaoSoc || dadosParticipacaoSoc.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>


      <m-expansion-panel *ngIf="MostrarConsultaCredito" [id]="'accDadosConsultaCredito'" [title]="'Consultas ao CPF'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosConsultaCredito && dadosConsultaCredito.length > 0">
          <table id="id-table-infConsultasCPF" class="table table-striped table-borderless" aria-label="Tabala de consultas de CPF">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="30%">Empresa</th>
                <th scope="col" width="20%">CNPJ</th>
                <th scope="col" width="10%">Data</th>
                <th scope="col" width="10%">Quantidade</th>
                <th scope="col" width="15%">Finalidade</th>
                <th scope="col" width="15%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of sortByAtributo(dadosConsultaCredito, 'atributo', 'DESC'); index as i">
                <td> {{ dados.empresa | naoinformado }}</td>
                <td>{{ dados.cnpj | naoinformado }}</td>
                <td>{{ dados.dtSearch | date:"dd/MM/yyyy" | naoinformado}}</td>
                <td>{{ dados.numSearches | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosConsultaCredito-nao-encontrado" class="info-not-found"
          *ngIf="!dadosConsultaCredito || dadosConsultaCredito.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarConsultaLockUnlock" [id]="'accDadosConsultaLockUnlock'"
        [title]="'Consultas à Serasa - Lock&Unlock'" [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosConsultaLockUnlock && dadosConsultaLockUnlock.length > 0">
          <table id="id-table-infConsultasCPF" class="table table-striped table-borderless" aria-label="Tabala de consultas de CPF Lock&Unlock" style="font-size: smaller;">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="30%">Empresa</th>
                <th scope="col" width="20%">CNPJ</th>
                <th scope="col" width="10%">Data</th>
                <th scope="col" width="10%">Quantidade</th>
                <th scope="col" width="15%">Finalidade</th>
                <th scope="col" width="15%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">
              <tr *ngFor="let dados of sortByAtributo(dadosConsultaLockUnlock, 'atributo', 'DESC'); index as i">
                <td> {{ dados.empresa | naoinformado }}</td>
                <td>{{ dados.cnpj | naoinformado }}</td>
                <td>{{ dados.dtSearch | date:"dd/MM/yyyy" | naoinformado}}</td>
                <td>{{ dados.numSearches | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosConsultaLockUnlock-nao-encontrado" class="info-not-found"
          *ngIf="!dadosConsultaLockUnlock || dadosConsultaLockUnlock.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarConsultaCertificado" [id]="'accDadosConsultaCertificado'" [title]="'Dados de Certificado Digital'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosConsultaCertificado && dadosConsultaCertificado.length > 0">
          <table id="id-table-infConsultasCPF" class="table table-striped table-borderless" aria-label="Tabala de Dados de Certificado Digital">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">

              <tr *ngFor="let dados of sortByAtributo(dadosConsultaCertificado, 'atributo', 'DESC'); index as i">
                <td> {{ dados.atributo | naoinformado }}</td>
                <td>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosConsultaCertificado-nao-encontrado" class="info-not-found"
          *ngIf="!dadosConsultaCertificado || dadosConsultaCertificado.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarDocumentosExtraviados" [id]="'accDadosDocumentosExtraviados'" [title]="'Dados de Documentos Extraviados'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosDocumentosExtraviados && dadosDocumentosExtraviados.length > 0">
          <table id="id-table-infConsultasCPF" class="table table-striped table-borderless" aria-label="Tabela de Documentos Extraviados">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="40%">Informação</th>
                <th scope="col" width="20%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">

              <tr *ngFor="let dados of sortByAtributo(dadosDocumentosExtraviados, 'atributo', 'DESC'); index as i">
                <td> {{ dados.atributo | naoinformado }}</td>
                <td>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosDocumentosExtraviados-nao-encontrado" class="info-not-found"
          *ngIf="!dadosDocumentosExtraviados || dadosDocumentosExtraviados.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <m-expansion-panel *ngIf="MostrarScr" [id]="'accDadosScr'" [title]="'Dados SCR - Bacen'"
        [active]="larguraEhSuperiorMin">
        <div class="table-responsive" *ngIf="dadosScr && dadosScr.length > 0">
          <table id="id-table-scr" class="table table-striped table-borderless" aria-label="Tabela de Dados de Scr - Bacen">
            <thead>
              <tr class="etiqueta">
                <th scope="col" width="15%">Atributo</th>
                <th scope="col" width="10%">Instituição financeira</th>
                <th scope="col" width="15%">Contrato</th>
                <th scope="col" width="15%">Modalidade</th>
                <th scope="col" width="15%">Data de referência</th>
                <th scope="col" width="10%">Informação</th>
                <th scope="col" width="10%">Finalidade</th>
                <th scope="col" width="25%">Origem</th>
              </tr>
            </thead>
            <tbody class="header">

              <tr *ngFor="let dados of sortByAtributo(dadosScr, 'atributo', 'ASC'); index as i">
                <td> {{ dados.atributo | naoinformado }}</td>
                <td>{{ dados.financialInstitution | naoinformado }}</td>
                <td>{{ dados.contract | naoinformado }}</td>
                <td>{{ dados.modality | naoinformado }}</td>
                <td>{{ dados.referenceDate | naoinformado }}</td>
                <td>{{ dados.informacao | naoinformado }}</td>
                <td>{{ dados.finalidade | naoinformado }}</td>
                <td>{{ dados.origem | naoinformado }}</td>
            </tbody>
          </table>
        </div>
        <div id="id-div-dadosConsultaScr-nao-encontrado" class="info-not-found"
          *ngIf="!dadosScr || dadosScr.length == 0">Nenhuma informação
          encontrada
        </div>
      </m-expansion-panel>

      <div *ngIf="disclaimerdadosConsultaLockUnlock" [id]="'NotasLockUnlock'">
        <app-alert [tipo]="'info'">
          'Esse relatório disponibiliza as tentativas de consultas realizadas por terceiros durante o período em que você
          utilizou a ferramenta Lock&Unlock e seu Serasa Score esteve bloqueado.'
        </app-alert>
      </div>

      <div *ngIf="disclaimerMarketing" [id]="'NotasMarketing'">
        <app-alert [tipo]="'info'">
          Dados pessoais tratados para a finalidade &#34;Direcionamento de Ofertas&#34; visam a segmentar perfis que ajudam
          as empresas a se comunicarem com você com mais eficiência. Você pode solicitar a interrupção ou a retomada do
          tratamento dos seus dados pessoais para a finalidade de direcionamento de ofertas.
        </app-alert>
      </div>

      <div *ngIf="disclaimerCredito" [id]="'NotasCredito'">
        <app-alert [tipo]="'info'">
          Dados pessoais tratados para a finalidade &#34;Proteção ao Crédito&#34; compõem soluções que visam a apoiar
          decisões de crédito e negócios com mais assertividade e agilidade, permitindo uma melhor gestão de riscos para o
          sistema de crédito.
        </app-alert>
      </div>

      <div *ngIf="disclaimerFraude" [id]="'NotasFraude'">
        <app-alert [tipo]="'info'">
          Dados pessoais tratados para a finalidade &#34;Autenticação de indivíduos e Prevenção a fraudes&#34; compõem
          soluções que visam a apoiar a confirmação de sua identidade com mais precisão e agilidade e a prevenir possíveis
          fraudes a você e ao mercado.
        </app-alert>
      </div>

      <div *ngIf="disclaimerDataQuality" [id]="'NotasDataQuality'">
        <app-alert [tipo]="'info'">
          Dados pessoais tratados para a finalidade &#34;Aprimoramento da Qualidade de Dados&#34; visam a auxiliar as
          empresas a cumprir o princípio da qualidade, mantendo os seus dados atualizados.
        </app-alert>
      </div>

      <div *ngIf="disclaimerCertificado" [id]="'NotasCertificado'">
        <app-alert [tipo]="'info'">
          Dados pessoais tratados para a finalidade &#34;Certificado Digital&#34; visam auxiliar a confirmação de sua identidade
          com mais precisão.
        </app-alert>
      </div>

      <div *ngIf="disclaimerScr" [id]="'NotasScr'">
        <app-alert [tipo]="'info'">
          Carteira Ativa: Valor total contratado da operação; incluindo todos os pagamentos a vencer e vencidos.
        </app-alert>
      </div>

      <p class="texto-final-pagina">
        Os bancos de dados da Serasa Experian são compostos por dados provenientes de diferentes fontes, como cadastro
        em nossos sites, clientes e parceiros com quem você tem ou teve relacionamento comercial, repositórios
        publicamente disponíveis, dentre outros.
      </p>
      <p class="texto-final-pagina">
        Todos os dados são armazenados em ambiente seguro e possuem prazo de retenção e de descarte determinados de
        acordo com a legislação aplicável, condições contratuais e Políticas Internas do grupo Experian.
      </p>
      <p class="texto-final-pagina">
        A Serasa S.A. tem sede na Avenida das Nações Unidas, 14401 – Torre C-1, Parque da Cidade, 19º a
        24º andares, em São Paulo/SP, e está inscrita no CNPJ/MF sob o nº 62.173.620/0001-80.
      </p>
      <p class="texto-final-pagina">
        A Serasa Experian adota robustas políticas de segurança e governança de dados baseados nas legislações vigentes
        nas melhores práticas de mercado, visando abranger todo o ciclo de vida do dado, desde a coleta até a sua
        exclusão.
      </p>
      <p class="texto-final-pagina">
        A Serasa Experian utiliza critérios objetivos no tratamento de dados pessoais, como a limitação aos dados
        mínimos para o atendimento de cada finalidade de uso e procedimentos para verificar a qualidade dos dados, sem
        qualquer juízo de valor.
      </p>
    </div>
    <a routerLink="/relatorio-sintetico" routerLinkActive="active" style="text-decoration: none;">
      <div class="modal-body-title" id="controlessolicitarRelAnaliticoMsg" style="padding: 0px"
        *ngIf="controlessolicitarRelAnalitico === false && noInfoFoundAlertActive">

        <app-alert [titulo]="'Nada encontrado'" [tipo]="'info'">
          <p>Não existe solicitação de informações para o seu documento. Acesse
            <span style="color:#1d4f91">aqui</span> para solicitar uma consulta
          </p>
        </app-alert>
      </div>
    </a>

    <div class="modal-body-title" id="controlessolicitarRelAnaliticoMsg" style="padding: 0px"
      *ngIf="controlessolicitarRelAnalitico === false && infoAlertActive">
      <app-alert [titulo]="'Em processamento'" [tipo]="'info'">
        <p>{{menssagemAtencao}}</p>
      </app-alert>
    </div>

    <div class="modal-body-title" id="controlessolicitarRelAnaliticoMsg"
      *ngIf="controlessolicitarRelAnalitico === false && errorAlertActive">

      <app-alert [titulo]="'Erro'" [tipo]="'danger'">
        <p>{{menssagemErro}}</p>
      </app-alert>

    </div>

  </div>
</div>
<app-modal-erro #modalErro [titulo]="'Ops, ocorreu um erro!'"
  [mensagem]="'Não foi possivel baixar o PDF nesse momento!'" [hidden]="abrirModalErroPdf"></app-modal-erro>
